import { Geo } from "@tenderd/schema";
import React, { useContext } from "react";
export var DateContext = React.createContext({
    getGeoDate: function (data) { return new Date(); },
});
export var useGeoDate = function () {
    return useContext(DateContext);
};
export var DateProvider = function (props) {
    var getGeo = function () {
        var storedGeo = window.localStorage.getItem("geoOverride");
        var geo = Geo.UAE;
        if (storedGeo) {
            geo = storedGeo;
        }
        return geo;
    };
    var getGeoDate = function (date) {
        var tz;
        switch (getGeo()) {
            case Geo.UAE:
            case Geo.AUH:
                tz = 'Asia/Dubai';
                break;
            case Geo.NG:
                tz = 'Africa/Lagos';
                break;
            case Geo.NL:
                tz = 'Europe/Amsterdam';
                break;
            case Geo.SA:
                tz = 'Asia/Riyadh';
                break;
            default:
                tz = 'Asia/Dubai';
                break;
        }
        return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: tz }));
    };
    return (React.createElement(DateContext.Provider, { value: {
            getGeoDate: getGeoDate
        } }, props.children));
};
